<template>
  <div v-title data-title="专题活动">
    <div>
      <div style="width:100%;text-align:center">
        <img
          src="../../assets/img/nospecialevent.png"
          style="width:200px; margin-top:50px"
        />
      </div>

      <p style="color:#abb7bf;text-align:center;margin-top:20px">亲，暂无专题活动</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "nospecialevent",
  data: function() {},
  methods: {}
};
</script>

 


// WEBPACK FOOTER //
// src/components/specialevent/nospecialevent.vue